const real = (abs: number, arg: number): number => abs * Math.cos(arg);

export default real;
